import load from "load-script";
import qs from "querystring";

const config = {
  v: '1.4.15',
  key: 'd3a562834fc3c90bc7673834e478bd08',
  plugin: 'AMap.Geolocation, AMap.PlaceSearch, AMap.Geocoder',
}
const SDK = "https://webapi.amap.com/maps?"
const UISDK = "https://webapi.amap.com/ui/1.0/main.js?v=1.0.11"
let isAmapInited = false


const setup = () => {
  return new Promise((resolve, reject) => {

    if (isAmapInited) { // 如果已经加载过
      resolve()
      return
    }

    load(`${SDK}${qs.stringify(config)}`,{
      async: true,
    }, (err, Script) => {
      if (err) {
        reject('amap sdk load fail')
        return console.warn("amap sdk load fail");
      }
      load(UISDK, {
        async: true,
      }, (err, script) => {

        if (err) {
          reject("amap ui sdk load fail")
          return console.warn("amap ui sdk load fail");
        }
        isAmapInited = true
        resolve()
      })
    })
  })

}

// setTimeout(() => {
//   setup()
// }, 0);
/**
 *
 * @param {Object} source 起点
 * @param {Object} dest 终点
 */
export const navigationByPostion = (source, dest) => {
  source = {
    lat: source.latitude || source.lat || source.la || 0,
    lng: source.longitude || source.lng || source.lo || 0,
    name: source.name || "起点"
  };
  dest = {
    lat: dest.latitide || dest.lat || dest.la || 0,
    lng: dest.longitude || dest.lng || dest.lo || 0,
    name: dest.name || "终点"
  };
  //跳转amap的导航
  let url = "https://m.amap.com/navigation/carmap/";
  url += `saddr=${source.lng},${source.lat},${source.name}&daddr=${dest.lng},${dest.lat},${dest.name}&sort=dist`;
  window.location.href = url;
};
/**
 *
 * @param {Number} pageSize 单页显示结果条数
 * @param {String} keyword 关键字
 * @param {LngLat} cpoint 中心点经纬度
 * @param {Number} radius 半径,取值范围：0-50000
 * @param {String} type 兴趣点类别， 默认值：餐饮服务、商务住宅、生活服务
 */
export const placeSearchNearby = ({
  pageSize = 5,
  keyword = "",
  cpoint,
  radius = 200,
  type
}) => {

  return setup().then(() => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        AMap.service("AMap.PlaceSearch", () => {
          var placeSearch = new AMap.PlaceSearch({
            type: type || "餐饮服务|商务住宅|生活服务",
            pageSize, // 单页显示结果条数
            pageIndex: 1, // 页码
            autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            extensions: "all" // 返回基本+详细信息
          });
          placeSearch.searchNearBy(keyword, cpoint, radius, (status, result) => {
            console.log("nearby", status, result);
            if (status == "complete" && result.info == "OK") {
              return resolve(result.poiList.pois);
            }
            return reject([]);
          });
        });
      }, 100);
    });
  })
};
/**
 * @param {Object} query 地址查询条件
 */
export const placeSearch = query => {
  const PlaceSearchOptions = {
    citylimit: true, // 是否强制限制在设置的城市内搜索，默认值为：false
    city: "全国", // 兴趣点城市
    pageSize: 5, // 单页显示结果条数
    pageIndex: 1, // 页码
    autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
    extensions: "all" // 返回基本+详细信息
  };
  console.log({
    ...PlaceSearchOptions,
    ...query
  });

  return setup().then(() => {
    return new Promise((resolve, reject) => {
      AMap.service("AMap.PlaceSearch", () => {
        var placeSearch = new AMap.PlaceSearch({
          ...PlaceSearchOptions,
          ...query
        });
        placeSearch.search(query.keyword, (status, result) => {
          console.log("search", status, result);

          if (status == "complete" && result.info == "OK") {
            return resolve(query.keyword && result.poiList.pois);
          }
          return reject([])
        })
      })
    })
  })

}

/**
 * 正向地理编码，地址转化坐标
 * @param {string} address 地址
 */
export const geoCode = address => {
  return setup().then(() => {

    return new Promise((resolve, reject) => {
      AMap.plugin("AMap.Geocoder", function() {
        var geocoder = new AMap.Geocoder();
        console.log(address)
        geocoder.getLocation(address, (status, result) => {
          console.log('geocoder', status, result)
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            return resolve(lnglat);
          }
          return reject("");
        });
      });
    });
  })
};

export const initAmap = () => {
  return setup()
}
